module.exports = __webpack_public_path__ + "static/media/t_icon_01.c1ac7601.png";